import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import { Col, Card, Row } from 'reactstrap';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  USERS_SUCCESS,
  USERS_FAILED,
  userClearState as userClearStateAction,
  getAsyncData as getAsyncDataAction,
} from '../../../../redux/actions/usersAction';
import WizardFormOne from './WizardFormOne';
import WizardFormTwo from './WizardFormTwo';
import WizardFormThree from './WizardFormThree';
import WizardFormFour from './WizardFormFour';
import WizardFormFive from './WizardFormFive';
import { FullWideNotification } from '../../../../shared/components/Notification';

class WizardForm extends PureComponent {
  static propTypes = {
    history: PropTypes.objectOf(PropTypes.any).isRequired,
    asyncData: PropTypes.objectOf(PropTypes.any).isRequired,
    asyncStatus: PropTypes.string.isRequired,
    submitStatus: PropTypes.string.isRequired,
    showNotification: PropTypes.func.isRequired,
    getAsyncData: PropTypes.func.isRequired,
    userClearState: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.state = {
      page: 1,
    };
  }

  componentDidMount() {
    const { getAsyncData } = this.props;
    getAsyncData();
  }

  componentWillReceiveProps(nextProps) {
    const { submitStatus, history } = nextProps;

    if (submitStatus === USERS_SUCCESS) {
      history.push('/users');
    } else if (submitStatus === USERS_FAILED) {
      this.show('danger', 'Произошла непредвиденная ошибка. Обратитесь к разработчикам.');
    }
  }

  componentWillUnmount() {
    const { userClearState } = this.props;
    userClearState();
  }

  show = (color, message) => {
    const { showNotification } = this.props;
    return showNotification({
      notification: <FullWideNotification color={color} message={message} />,
      position: 'full',
    });
  };

  nextPage = () => {
    this.setState((prevState) => ({ page: prevState.page + 1 }));
  };

  previousPage = () => {
    this.setState((prevState) => ({ page: prevState.page - 1 }));
  };

  render() {
    const { showNotification, asyncStatus, asyncData } = this.props;
    const { countries, timezones } = asyncData;
    const { page } = this.state;

    return (
      <Row>
        <Col md={12} lg={12}>
          <Card>
            <div className="wizard">
              <div className="wizard__steps">
                <div className={`wizard__step${page === 1 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 1</p>
                </div>
                <div className={`wizard__step${page === 2 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 2</p>
                </div>
                <div className={`wizard__step${page === 3 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 3</p>
                </div>
                <div className={`wizard__step${page === 4 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 4</p>
                </div>
                <div className={`wizard__step${page === 5 ? ' wizard__step--active' : ''}`}>
                  <p>Шаг 5</p>
                </div>
              </div>
              {asyncStatus === USERS_SUCCESS && (
                <div className="wizard__form-wrapper">
                  {page === 1 && <WizardFormOne countries={countries} timezones={timezones} onSubmit={this.nextPage} />}
                  {page === 2 && <WizardFormTwo previousPage={this.previousPage} onSubmit={this.nextPage} />}
                  {page === 3 && <WizardFormThree previousPage={this.previousPage} onSubmit={this.nextPage} />}
                  {page === 4 && <WizardFormFour previousPage={this.previousPage} onSubmit={this.nextPage} />}
                  {page === 5 && (
                    <WizardFormFive previousPage={this.previousPage} showNotification={showNotification} />
                  )}
                </div>
              )}
            </div>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  asyncData: state.users.asyncData,
  asyncStatus: state.users.asyncStatus,
  submitStatus: state.users.submitStatus,
});

const mapDispatchToProps = (dispatch) => ({
  getAsyncData: () => dispatch(getAsyncDataAction()),
  userClearState: () => dispatch(userClearStateAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(withRouter(WizardForm)));
